import { useMemo } from "react";

import { useSelector } from "react-redux";

import {
    StyledContactsActionsPanel,
    StyledInnerContainer,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/components/ContactsTableActionsPanel/styles";
import ContactsRevealActionButtonContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ContactsRevealActionButton";
import ContactsExportDropdownContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ExportVariantsDropdown";
import {
    useInvalidateContactSearchResultAsync,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import {
    selectIsPanelExportActive,
    selectMultipleRevealIsInProgress,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";

import { useOpportunityListContactsResults } from "../../../hooks/useOpportunityListContactsResults";
import ContactsExportPanelContainer from "../ContactsExportPanel/ContactsExportPanelContainer";
import ContactsRevealPanelContainer from "../ContactsRevealPanel/ContactsRevealPanelContainer";

const ContactsTableActionsPanelContainer = () => {
    const { data, isFetching } = useOpportunityListContactsResults();
    const invalidateContactSearchResult = useInvalidateContactSearchResultAsync();
    const isExportFlowActive = useSelector(selectIsPanelExportActive);
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    const numberOfResults = data?.totalCount ?? 0;

    const defaultActiveChild = useMemo(() => {
        if (isExportFlowActive) {
            return ContactsExportPanelContainer;
        }
        if (isMultipleRevealInProgress) {
            return ContactsRevealPanelContainer;
        }
        return undefined;
    }, [isExportFlowActive, isMultipleRevealInProgress]);

    return (
        <StyledContactsActionsPanel defaultActiveChild={defaultActiveChild}>
            {({ activate }) => {
                function activateRevealPanel() {
                    activate(() => ContactsRevealPanelContainer);
                }

                function handlePanelActivate() {
                    activate(() => ContactsExportPanelContainer);
                }

                return (
                    <StyledInnerContainer>
                        <ContactsRevealActionButtonContainer
                            isLoading={isFetching}
                            numberOfResults={numberOfResults}
                            onClick={activateRevealPanel}
                            onApprove={invalidateContactSearchResult}
                        />
                        <ContactsExportDropdownContainer
                            isLoading={isFetching}
                            numberOfResults={numberOfResults}
                            onActivate={handlePanelActivate}
                        />
                    </StyledInnerContainer>
                );
            }}
        </StyledContactsActionsPanel>
    );
};

export default ContactsTableActionsPanelContainer;
